﻿/**
 * onisa-cart-pack-swap.js  — v2
 *
 * ARQUITECTURA: "Fila virtual" — el carrito puede contener Pack de 2 + 1 Unidad
 * internamente, pero el usuario SIEMPRE ve UNA fila por producto/color/talla con:
 *   • Cantidad total en unidades individuales (no en "packs")
 *   • Precio original tachado  +  precio real con descuento
 *   • Botones ± que ajustan unidades individuales y recalculan el mix óptimo de packs
 *
 * Algoritmo greedy (pack más grande primero):
 *   qty=1 → 1×unitaria
 *   qty=2 → 1×Pack de 2
 *   qty=3 → 1×Pack de 2 + 1×unitaria  (precio óptimo: €89,95 + €49,95 = €139,90)
 *   qty=4 → 2×Pack de 2  (o 1×Pack de 4 si existe y es más barato)
 *
 * Requiere data-pack-group / data-pack-size / data-pack-map / data-unit-variant /
 * data-unit-price en cada <tr> de carrito, generados por oc-pack-map.liquid.
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────────────
     UTILIDADES
  ───────────────────────────────────────────────────────────────────────── */

  function parseJSON(str) {
    try { return JSON.parse(str || '{}'); } catch (_) { return {}; }
  }

  /** Formatea céntimos como "€49,95" */
  function eur(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  /**
   * Greedy: pack más grande primero.
   * packMap = {"2":{"id":X,"price":Y}, "4":{"id":Z,"price":W}}
   * Devuelve [{variantId, qty, packSize, priceEach}]
   */
  /**
   * Greedy allocation con soporte para packs "unidad gratis" (ej: "3+1 Gratis").
   *
   * Auto-upgrade: si existe un pack en packSize = totalUnits+1 cuyo precio es
   * ≤ totalUnits × unitPriceCents, la unidad extra sale gratis → se aplica.
   * Ejemplo: 3 fundas a €79,95 c/u (= €239,85) → "4 Unidades (3+1 Gratis)"
   * también a €239,85 → la 4ª es gratis; se devuelve Pack de 4.
   *
   * Para suprimir el auto-upgrade (decrementos explícitos del usuario),
   * pasar unitPriceCents = 0.
   */
  function optimalAlloc(totalUnits, packMap, unitVariantId, unitPriceCents) {
    var packs = Object.keys(packMap).map(function (k) {
      var v = packMap[k];
      return { packSize: parseInt(k, 10), id: parseInt(v.id, 10), price: parseInt(v.price, 10) };
    }).sort(function (a, b) { return b.packSize - a.packSize; });

    /* ── Auto-upgrade "unidad gratis": packSize = totalUnits+1 y packPrice ≤ totalUnits × unitPrice ── */
    if (unitPriceCents && totalUnits > 0) {
      for (var u = 0; u < packs.length; u++) {
        var up = packs[u];
        if (up.packSize === totalUnits + 1 && up.price <= totalUnits * unitPriceCents) {
          return [{ variantId: up.id, qty: 1, packSize: up.packSize, priceEach: up.price }];
        }
      }
    }

    var result = [];
    var rem = totalUnits;
    for (var i = 0; i < packs.length; i++) {
      var p = packs[i];
      if (rem >= p.packSize) {
        var n = Math.floor(rem / p.packSize);
        result.push({ variantId: p.id, qty: n, packSize: p.packSize, priceEach: p.price });
        rem -= n * p.packSize;
      }
    }
    if (rem > 0) {
      result.push({ variantId: parseInt(unitVariantId, 10), qty: rem, packSize: 1, priceEach: null });
    }
    return result;
  }

  function allocTotalCents(alloc, unitPriceCents) {
    return alloc.reduce(function (sum, a) {
      return sum + a.qty * (a.priceEach !== null ? a.priceEach : parseInt(unitPriceCents, 10));
    }, 0);
  }

  /* ─────────────────────────────────────────────────────────────────────────
     ESTILOS
  ───────────────────────────────────────────────────────────────────────── */

  function injectCSS() {
    if (document.getElementById('oc-pswap-css')) return;
    var s = document.createElement('style');
    s.id = 'oc-pswap-css';
    s.textContent = [
      /* Filas reales ocultas tras crear la fila virtual */
      '.oc-pack-real { display: none !important; }',
      /* Precio tachado en fila virtual */
      '.oc-vrow .oc-price-old {',
      '  text-decoration: line-through;',
      '  color: #888888;',
      '  font-size: 0.9em;',
      '  margin-right: 6px;',
      '}',
      '.oc-vrow .oc-price-new { font-weight: 600; color: #0e0e0e; }',
      /* Ocultar la opción "Pack de X" / "Cantidad" en el detalle de la fila virtual */
      '.oc-vrow .oc-option-pack { display: none !important; }',
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ─────────────────────────────────────────────────────────────────────────
     DETECCIÓN DE GRUPOS
  ───────────────────────────────────────────────────────────────────────── */

  /**
   * Devuelve grupos de filas REALES agrupadas por data-pack-group,
   * DENTRO de un contenedor específico.
   * Excluye filas virtuales (data-pack-vkey) para evitar bucle infinito.
   */
  function collectGroups(container) {
    var rows = (container || document).querySelectorAll('tr[data-pack-group]:not([data-pack-vkey])');
    var map = {};
    for (var i = 0; i < rows.length; i++) {
      var key = rows[i].dataset.packGroup;
      if (!key) continue;
      if (!map[key]) map[key] = [];
      map[key].push(rows[i]);
    }
    return map;
  }

  /* ─────────────────────────────────────────────────────────────────────────
     RENDERIZADO DE FILA VIRTUAL
  ───────────────────────────────────────────────────────────────────────── */

  function renderVirtualRow(groupKey, rows) {
    var anchor = rows[0];

    /* Eliminar fila virtual anterior para este grupo SOLO en el mismo tbody.
       Scoping al tbody evita conflictos entre la página /cart y el drawer. */
    var tbody = anchor.parentElement;
    var existing = tbody.querySelectorAll('[data-pack-vkey]');
    for (var x = 0; x < existing.length; x++) {
      if (existing[x].dataset.packVkey === groupKey) existing[x].remove();
    }

    /* SEGURIDAD: Asegurarse de que las filas reales son visibles ANTES de intentar
       crear la virtual. Si la creación falla por cualquier motivo (timing, DOM parcial,
       input vacío), el usuario verá el producto real en lugar de una fila fantasma. */
    rows.forEach(function (r) { r.classList.remove('oc-pack-real'); });

    var packMap = parseJSON(anchor.dataset.packMap);
    var unitVariantId = anchor.dataset.unitVariant;
    var unitPrice = parseInt(anchor.dataset.unitPrice || '0', 10);

    /* Total de unidades individuales en el grupo */
    var totalUnits = 0;
    for (var i = 0; i < rows.length; i++) {
      var sz  = parseInt(rows[i].dataset.packSize || '1', 10);
      var inp = rows[i].querySelector('.quantity__input');
      var q   = inp ? (parseInt(inp.value, 10) || 0) : 0;
      totalUnits += sz * q;
    }
    /* Si no hay unidades (ej. input aún no poblado), dejar filas reales visibles
       y salir. El MutationObserver o el setTimeout reintentarán. */
    if (totalUnits === 0) return;

    /* Precios — con detección de auto-upgrade "unidad gratis" */
    var alloc          = optimalAlloc(totalUnits, packMap, unitVariantId, unitPrice);
    var allocatedUnits = alloc.reduce(function (s, a) { return s + a.qty * a.packSize; }, 0);

    /* Auto-upgrade silencioso (ej: "3+1 Gratis").
       Si el pack óptimo tiene más unidades que las solicitadas, actualizamos el carrito
       para que el usuario reciba la unidad extra.
       Excepción: si el usuario acaba de decrementar explícitamente a esta cantidad
       (_lastRenderedQty[groupKey] === totalUnits), respetamos su decisión y usamos
       la asignación greedy normal en su lugar. */
    if (allocatedUnits > totalUnits && !_busy) {
      var _prevRend    = _lastRenderedQty[groupKey];
      var _suppressed  = (_prevRend !== undefined && _prevRend === totalUnits);
      if (!_suppressed) {
        /* Lanzar actualización silenciosa y salir — las filas reales quedan visibles */
        setTimeout(function () { fireGroupUpdate(groupKey, rows, allocatedUnits); }, 0);
        return;
      }
      /* Usuario eligió explícitamente esta cantidad → mostrar asignación greedy */
      alloc          = optimalAlloc(totalUnits, packMap, unitVariantId, 0);
      allocatedUnits = totalUnits;
    }

    /* Guardar cantidad renderizada para detectar decrementos futuros */
    _lastRenderedQty[groupKey] = totalUnits;

    var actualCents = allocTotalCents(alloc, unitPrice);
    var fullCents   = totalUnits * unitPrice;
    var hasDiscount = actualCents < fullCents;

    /* Clonar la primera fila real como plantilla */
    var vrow = anchor.cloneNode(true);
    vrow.classList.add('oc-vrow');
    vrow.dataset.packVkey = groupKey;
    vrow.removeAttribute('id');

    /* ── 1. Input de cantidad: mostrar total de unidades ── */
    var qInput = vrow.querySelector('.quantity__input');
    if (qInput) {
      qInput.value = totalUnits;
      qInput.dataset.packVkey = groupKey;
      /* min=0 para permitir borrar ítem; max razonable */
      qInput.setAttribute('min', '0');
      qInput.setAttribute('max', '20');
      /* Evitar que Dawn lo asocie a una línea específica */
      qInput.removeAttribute('data-index');
    }

    /* ── 2. Ocultar opción "Pack" / "Cantidad" ── */
    var opts = vrow.querySelectorAll('.product-option');
    for (var j = 0; j < opts.length; j++) {
      var dt = opts[j].querySelector('dt');
      if (dt) {
        var label = dt.textContent.trim();
        if (label === 'Pack:' || label === 'Cantidad:') {
          opts[j].classList.add('oc-option-pack');
        }
      }
    }

    /* ── 3. Actualizar precios en el panel de detalles (móvil) ── */
    var priceHTML = hasDiscount
      ? '<s class="oc-price-old">' + eur(fullCents) + '</s>'
        + '<strong class="oc-price-new">' + eur(actualCents) + '</strong>'
      : '<span>' + eur(actualCents) + '</span>';

    /* Actualizar TODOS los contenedores de precio unitario (Dawn genera varios para
       distintos breakpoints: .medium-hide, .small-hide, etc.) */
    var detailPrices = vrow.querySelectorAll(
      '.cart-item__discounted-prices, .cart-item__price-wrapper'
    );
    for (var dp = 0; dp < detailPrices.length; dp++) {
      /* Solo actualizar los que estén dentro de .cart-item__details,
         no los de .cart-item__totals (esos se tratan abajo) */
      if (!detailPrices[dp].closest('.cart-item__totals')) {
        detailPrices[dp].innerHTML = priceHTML;
      }
    }

    /* ── 4. Actualizar precio total (columna derecha) — TODAS las celdas ──
       Dawn genera 3 .cart-item__totals (off-screen, mobile-only, desktop-only).
       Actualizamos todas para que sea correcto en cualquier breakpoint. */
    var totalHTML = hasDiscount
      ? '<div class="cart-item__price-wrapper">'
        + '<s class="oc-price-old">' + eur(fullCents) + '</s>'
        + '<strong class="oc-price-new">' + eur(actualCents) + '</strong>'
        + '</div>'
      : '<div class="cart-item__price-wrapper">'
        + '<span class="price price--end">' + eur(actualCents) + '</span>'
        + '</div>';

    var totalsCells = vrow.querySelectorAll('.cart-item__totals');
    for (var tc = 0; tc < totalsCells.length; tc++) {
      totalsCells[tc].innerHTML = totalHTML;
    }

    /* ── 5. Botón "Eliminar" — interceptar ANTES de que cart-remove-button custom element actúe ── */
    var removeBtn = vrow.querySelector('cart-remove-button');
    if (removeBtn) {
      /* Registro antes de insertar en DOM → mi listener se añade ANTES que el constructor del custom element */
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        fireGroupUpdate(groupKey, rows, 0);
      });
    }

    /* ── 6. Eliminar oc-pack-real heredada del clon ── */
    vrow.classList.remove('oc-pack-real');

    /* ── 7. Pre-procesar imágenes del clon ANTES de insertar en el DOM vivo. ── */
    var vImgs = vrow.querySelectorAll('img');
    for (var vi = 0; vi < vImgs.length; vi++) {
      vImgs[vi].removeAttribute('loading');
    }

    /* ── 8. Insertar fila virtual antes de la primera fila real ── */
    anchor.parentElement.insertBefore(vrow, anchor);

    /* ── 9. Ocultar filas reales DESPUÉS de que la virtual está en DOM ── */
    rows.forEach(function (r) { r.classList.add('oc-pack-real'); });

    /* ── 10. Escuchar cambios de cantidad en el input virtual ──
       QuantityInput custom element también escucha — nosotros capturamos DESPUÉS
       del step (QuantityInput already changed input.value) y prevenimos propagación */
    if (qInput) {
      qInput.addEventListener('change', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        var val = parseInt(this.value, 10);
        if (!isNaN(val) && val >= 0) {
          fireGroupUpdate(groupKey, rows, val);
        }
      }, true); /* capture=true para interceptar antes que QuantityInput */
    }
  }

  /* ─────────────────────────────────────────────────────────────────────────
     ACTUALIZACIÓN DEL CARRITO
  ───────────────────────────────────────────────────────────────────────── */

  var _busy = false;
  /* Rastrea la última cantidad RENDERIZADA por renderVirtualRow (no la solicitada).
     Permite detectar si el usuario está decrementando (para suprimir auto-upgrade). */
  var _lastRenderedQty = {};

  function fireGroupUpdate(groupKey, rows, totalUnits) {
    if (_busy) return;
    _busy = true;

    /* Feedback visual */
    var vrow = document.querySelector('[data-pack-vkey="' + groupKey + '"]');
    if (vrow) vrow.style.opacity = '0.4';

    var anchor    = rows[0];
    var packMap   = parseJSON(anchor.dataset.packMap);
    var unitVid   = parseInt(anchor.dataset.unitVariant, 10);
    var unitPrice = parseInt(anchor.dataset.unitPrice || '0', 10);

    /* Detectar si el usuario está decrementando respecto a lo último renderizado.
       Si es un decremento, pasamos unitPrice=0 → optimalAlloc usa greedy (sin upgrade).
       También pre-señalizamos a renderVirtualRow que esta cantidad es elección explícita. */
    var _prevRenderedQty = _lastRenderedQty[groupKey] !== undefined ? _lastRenderedQty[groupKey] : 0;
    var _isDecrement     = totalUnits < _prevRenderedQty;
    if (_isDecrement) {
      _lastRenderedQty[groupKey] = totalUnits; /* Suprimir auto-upgrade en siguiente render */
    }

    /* Construir updates={variantId:0} para todas las variantes del grupo */
    var zeros = {};
    zeros[unitVid] = 0;
    var pmVals = Object.values(packMap);
    for (var i = 0; i < pmVals.length; i++) {
      zeros[parseInt(pmVals[i].id, 10)] = 0;
    }

    /* Auto-upgrade activo solo cuando incrementando o en carga inicial */
    var alloc = optimalAlloc(totalUnits, packMap, String(unitVid), _isDecrement ? 0 : unitPrice);

    /* Paso 1: Poner a 0 todas las variantes del grupo */
    fetch('/cart/update.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: zeros })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('[oc-pack-swap] update zeros failed ' + r.status);
      if (totalUnits === 0) return null; /* solo borrar */

      /* Paso 2: Añadir la combinación óptima secuencialmente */
      return alloc.reduce(function (p, item) {
        return p.then(function () {
          return fetch('/cart/add.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: item.variantId, quantity: item.qty })
          }).then(function (r2) {
            if (!r2.ok) throw new Error('[oc-pack-swap] add failed ' + r2.status);
          });
        });
      }, Promise.resolve());
    })
    .then(function () {
      /* Paso 3: Refrescar secciones del carrito (Dawn).
         Actualizamos TODOS los elementos carrito presentes en DOM para que
         tanto la página /cart como el drawer queden sincronizados. */
      var cartEls = Array.from(
        document.querySelectorAll('cart-drawer-items, cart-items')
      );
      if (cartEls.length === 0) {
        window.location.reload();
        return;
      }
      /* Garantizar applyGrouping incluso si el observer falla */
      setTimeout(applyGrouping, 500);
      return Promise.all(
        cartEls.map(function (el) {
          return typeof el.onCartUpdate === 'function'
            ? el.onCartUpdate()
            : Promise.resolve();
        })
      );
    })
    .catch(function (err) {
      console.error(err);
      if (vrow) vrow.style.opacity = '';
    })
    .finally(function () {
      _busy = false;
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     APLICAR AGRUPACIÓN
  ───────────────────────────────────────────────────────────────────────── */

  /**
   * Aplica agrupación de forma independiente por cada contenedor de carrito.
   * Drawer y página /cart tienen tablas separadas → se procesan por separado.
   */
  function applyGrouping() {
    /* Contenedores posibles: cart-drawer-items y cart-items (página /cart) */
    var containers = Array.from(
      document.querySelectorAll('cart-drawer-items, cart-items')
    );
    /* Fallback: procesar el documento entero si no hay custom elements */
    if (containers.length === 0) containers = [null];

    containers.forEach(function (container) {
      var groups = collectGroups(container);
      Object.keys(groups).forEach(function (key) {
        /* renderVirtualRow oculta las filas reales solo tras crear exitosamente
           la virtual — garantía de que no quedan productos invisibles. */
        renderVirtualRow(key, groups[key]);
      });
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     PARCHE A CartItems

     NOTA TÉCNICA: CartItems.prototype.onChange está vinculado ("bound") en
     connectedCallback ANTES de que este script se cargue, por lo que parchear
     onChange en el prototipo NO afecta al listener ya registrado.

     En cambio, updateQuantity se resuelve por la cadena de prototipos EN EL
     MOMENTO DE LA LLAMADA, por lo que este parche SÍ funciona siempre.
  ───────────────────────────────────────────────────────────────────────── */

  function patchCartItems() {
    if (typeof CartItems === 'undefined') return;
    if (CartItems.prototype._oniPswap2) return;
    CartItems.prototype._oniPswap2 = true;

    var _origUpdateQty = CartItems.prototype.updateQuantity;
    CartItems.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      if (event && event.target) {
        var tgt = event.target;
        /* Input de fila virtual: manejado por nuestro listener (stopPropagation ya bloqueó, esto es defensa extra) */
        if (tgt.dataset && tgt.dataset.packVkey) return;
        /* Input de fila real oculta: ignorar */
        if (tgt.closest && tgt.closest('.oc-pack-real')) return;
      }
      return _origUpdateQty.call(this, line, quantity, event, name, variantId);
    };
  }

  /* ─────────────────────────────────────────────────────────────────────────
     OBSERVER: re-aplicar tras actualizaciones del carrito
     Problema: CartDrawer-CartItems se destruye y recrea en cada update de Dawn,
     así que observamos document.body con filtro para [data-pack-group].
  ───────────────────────────────────────────────────────────────────────── */

  function startObserver() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          /* Solo reaccionar a filas REALES de Dawn (sin data-pack-vkey).
             Las virtuales que nosotros insertamos NO deben disparar un nuevo ciclo. */
          if (node.querySelector && node.querySelector('[data-pack-group]:not([data-pack-vkey])')) {
            setTimeout(applyGrouping, 40);
            return; /* un solo disparo por batch de mutaciones */
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ─────────────────────────────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────────────────────────────── */

  function init() {
    injectCSS();

    if (typeof CartItems !== 'undefined') {
      patchCartItems();
    } else {
      customElements.whenDefined('cart-items').then(patchCartItems);
    }

    applyGrouping();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
